<template>
  <section id="how-it-works" class="py-24 bg-slate-50">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="text-center mb-16">
        <h2 class="text-3xl font-bold text-slate-900 mb-4">Jak to działa</h2>
        <p class="text-lg text-slate-600 max-w-2xl mx-auto">3 proste kroki, aby przygotować CV pod konkretną ofertę pracy.</p>
      </div>

      <div class="grid md:grid-cols-3 gap-8">
        <article class="bg-white p-8 rounded-2xl border border-slate-200">
          <div class="w-12 h-12 rounded-full bg-[#4F39F6] text-white grid place-items-center text-lg font-bold leading-none mb-5 mx-auto">1</div>
          <h3 class="text-xl font-semibold text-slate-900 mb-3">Wgraj CV</h3>
          <p class="text-slate-600 leading-relaxed">Prześlij swoje aktualne CV w formacie PDF lub importuj dane bezpośrednio z LinkedIn.</p>
        </article>

        <article class="bg-white p-8 rounded-2xl border border-slate-200">
          <div class="w-12 h-12 rounded-full bg-[#7F22FE] text-white grid place-items-center text-lg font-bold leading-none mb-5 mx-auto">2</div>
          <h3 class="text-xl font-semibold text-slate-900 mb-3">Wklej link do ogłoszenia</h3>
          <p class="text-slate-600 leading-relaxed">Dodaj link do oferty pracy z portali takich jak Pracuj.pl, LinkedIn lub inne platformy rekrutacyjne.</p>
        </article>

        <article class="bg-white p-8 rounded-2xl border border-slate-200">
          <div class="w-12 h-12 rounded-full bg-[#009966] text-white grid place-items-center text-lg font-bold leading-none mb-5 mx-auto">3</div>
          <h3 class="text-xl font-semibold text-slate-900 mb-3">Pobierz dopasowany PDF</h3>
          <p class="text-slate-600 leading-relaxed">Otrzymaj zoptymalizowane CV gotowe do wysłania. Bez ukrytych kosztów, bez niespodzianek.</p>
        </article>
      </div>
    </div>
  </section>
</template>
